import { FC } from 'react'

const DestinationCardSkeleton: FC = () => (
	<div className="destination-card-skeleton rounded-3xl overflow-hidden p-2 bg-white xl:w-1/4 shadow-[0px_2px_32px_0px_#1e293b1f]">
		{/* Image placeholder */}
		<div className="h-[214px] w-full bg-text-200 rounded-2xl animate-pulse" />
		{/* Content placeholder */}
		<div className="ps-2 pt-5">
			<div className="h-7 w-32 bg-text-200 rounded animate-pulse mb-0.5" />
			<div className="h-5 w-40 bg-text-200 rounded animate-pulse mb-8" />
			<div className="flex items-center justify-between">
				<div className="h-6 w-20 bg-text-200 rounded animate-pulse" />
				<div className="h-10 w-28 bg-text-200 rounded-full animate-pulse" />
			</div>
		</div>
	</div>
)

const PopularDestinationsSkeleton: FC = () => {
	return (
		<div className="relative xl:pb-11">
			{/* Title skeleton */}
			<div className="h-[32px] md:h-[38px] w-64 mx-auto bg-text-200 rounded-lg animate-pulse mb-0 xl:mb-11" />

			{/* Cards skeleton - 4 cards on desktop */}
			<div className="container flex gap-4 max-lg:hidden">
				{[1, 2, 3, 4].map((i) => (
					<DestinationCardSkeleton key={i} />
				))}
			</div>

			{/* Mobile carousel skeleton */}
			<div className="lg:hidden pl-4 pt-8 pb-6">
				<div className="flex gap-4 overflow-hidden">
					<div className="destination-card-skeleton min-w-[21rem] rounded-3xl p-2 bg-white shadow-[0px_2px_32px_0px_#1e293b1f]">
						<div className="h-[214px] w-full bg-text-200 rounded-2xl animate-pulse" />
						<div className="ps-2 pt-5">
							<div className="h-7 w-32 bg-text-200 rounded animate-pulse mb-0.5" />
							<div className="h-5 w-40 bg-text-200 rounded animate-pulse mb-8" />
							<div className="flex items-center justify-between">
								<div className="h-6 w-20 bg-text-200 rounded animate-pulse" />
								<div className="h-10 w-28 bg-text-200 rounded-full animate-pulse" />
							</div>
						</div>
					</div>
				</div>
				{/* Carousel controls placeholder */}
				<div className="flex flex-col items-center mt-6">
					<div className="flex justify-center items-center space-x-8">
						<div className="w-11 h-11 bg-text-200 rounded-full animate-pulse" />
						<div className="w-11 h-11 bg-text-200 rounded-full animate-pulse" />
					</div>
				</div>
			</div>
		</div>
	)
}

export default PopularDestinationsSkeleton

